import { getChangeRequestStatus } from '../constants/analyticsConstants';

/**
 * FE-FIX06. Заявка, зону которой потом удалили, продолжала выглядеть
 * действующей: badge «Одобрена» и текст, описывающий актуальную настройку.
 * Backend отдаёт `zone_deleted` / `zone_deleted_at` — используем их.
 *
 * Tombstone перекрывает только `approved`: отклонённая или ожидающая заявка
 * зону не создавала, и «Удалена» для неё смысла не имеет. Отсутствие
 * `zone_deleted` — это `false`, а не «неизвестно»: additive-поле может не
 * прийти со старого backend, и заявка тогда честно остаётся одобренной.
 */
export const requestDisplayStatus = (request) => {
  const status = request?.status;
  const deleted = status === 'approved' && request?.zone_deleted === true;

  if (deleted) return { label: 'Удалена', modifier: 'deleted', deleted: true };

  const base = getChangeRequestStatus(status);
  return { label: base.label, modifier: base.modifier, deleted: false };
};

export default requestDisplayStatus;
